import { post } from '@/common/request'

/** 聊天模块 */
export const im = {
    state: {
        ws: null,
        new_im_msg: {},
        timer: null,
        person_list: [],
    },
    mutations: {
        /** 初始化IM */
        init_im(state) {
            const that = this;
            var handler_biaoshi = ""; // 用于处理 重复消息
            function connect() {
                const nei_biaoshi = handler_biaoshi = Math.random().toString(36).substr(2);
                const ws = state.ws = new WebSocket('wss://www.muxintian.com:18763');
                ws.onopen = () => {
                    console.debug('连接成功',)
                    that.commit('im_auth');
                };
                ws.onerror = function (error) {
                    console.debug('连接错误:', error);
                };
                ws.onmessage = function (event) {
                    console.debug('收到消息:', event.data);
                    if (nei_biaoshi !== handler_biaoshi) return;
                    const data = JSON.parse(event.data);
                    if (!data.data) return;

                    if (JSON.stringify(data) != '{}') {
                        that.commit("update_not_read_msg_count", data.data)
                    }

                    state.new_im_msg = data;

                }
                ws.onclose = function (event) {
                    console.debug('连接关闭:', event);
                    setTimeout(() => {
                        clearInterval(state.timer);
                        connect();
                    }, 1000);
                }

                state.timer = setInterval(() => {
                    ws.send('PING');
                }, 1000 * 5);
            }
            connect();
        },
        /** IM鉴权 */
        im_auth(state) {
            console.debug('jianquan')
            const token = localStorage.getItem('token');
            if (token) {
                state.ws?.send(JSON.stringify({ action: 'auth', token }));
            }
        },
        /** 根据im消息更新用户未读消息数量 */
        update_not_read_msg_count(state, msg_info = {}) {
            const { from_uid, unread_num } = msg_info;
            console.debug('from_uid', from_uid)
            if (from_uid) {
                const index = state.person_list.findIndex(item => item.send_uid == from_uid)
                console.debug('index', index, msg_info)
                if (index != -1) {
                    const append_obj = { unread_num: unread_num || 0 };
                    if (msg_info.content != undefined) append_obj.content = msg_info.content;
                    if (msg_info.avatar != undefined) append_obj.avatar = msg_info.avatar;
                    if (msg_info.type != undefined) append_obj.type = msg_info.type;
                    if (msg_info.send_time != undefined) append_obj.send_time = msg_info.send_time;

                    state.person_list[index] = Object.assign({}, state.person_list[index], append_obj)
                    state.person_list = [...state.person_list]
                    console.debug('person_list', state.person_list[index])
                } else {
                    state.person_list = [{
                        send_uid: from_uid,
                        avatar: msg_info.avatar,
                        nickname: msg_info.nickname,
                        company_name: msg_info.company_name,
                        send_time: msg_info.send_time,
                        content: msg_info.content,
                        unread_num: msg_info.unread_num,
                        type: msg_info.type,
                    }, ...state.person_list]
                }
            }
        },
        /** 更新人员列表消息 */
        update_person_list(state, msg_info = {}) {
            state.person_list[msg_info.index] = Object.assign({}, state.person_list[msg_info.index], msg_info)
        },
        /** 页面首次进入追加新人 */
        add_new_person(state, msg_info = {}) {
            state.person_list = [msg_info, ...state.person_list]
        },
        /** 更新人员职位信息 */
        update_person_zhiwei_info(state, parms = {}) {
            const { person_id, job_info } = parms;
            console.debug('parms', parms)
            console.debug('person_id', person_id)
            console.debug('job_info', job_info)
            state.person_list.forEach((item, index) => {
                if (item.id == person_id) {
                    state.person_list[index].job = Object.assign({}, state.person_list[index].job, job_info)
                }
            })
        },
    },
    actions: {
        /** 获取人员列表 */
        async get_person_list({ state }) {
            try {
                const res = await post("v1.chat/chat_list", {})
                const res_list = res.data || []
                if (res_list.length && state.person_list.length) {
                    state.person_list.slice(0, res_list.length)
                }
                res_list.forEach((element, index) => {
                    if (!element.job) {
                        element.job = {
                            id: "",
                            title: "",
                        }
                    }
                    if (state.person_list[index]) state.person_list[index] = element
                    else state.person_list.push(element)
                });
            } catch (error) { }
        },
    }
}